<template>
    <div class="h-screen max-w-xs overflow-hidden flex flex-col items-center">
        <div class="h-3/5">
            <div v-for="(item, index) in slides" :key="index">
                <transition name="scale-up">
                    <carousel-item :image="item.img" :title="item.title" :subtitle="item.subtitle"
                        v-if="currentSlideIndex === index">
                    </carousel-item>
                </transition>
            </div>
        </div>
        <div class="flex flex-col justify-center items-center">
            <carousel-indicator :total="slides.length" :currentIndex="currentSlideIndex" />
            <Button @click="nextslide" color="primary" size="normal" class="z-0">Continue</Button>
        </div>
    </div>
</template>

<script>
import Button from '../Feed/Button.vue'
import CarouselItem from './CarouselItem.vue'
import CarouselIndicator from './CarouselIndicator.vue'
export default {
    props: {
        slides: Array,
    },
    components: { CarouselItem, Button, CarouselIndicator },
    data() {
        return {
            currentSlideIndex: 0,
        }
    },
    methods: {
        nextslide() {
            if (this.currentSlideIndex < this.slides.length - 1) return this.currentSlideIndex++;
            this.$router.replace('/');
        }
    }
}
</script>


